module.exports = __webpack_public_path__ + "img/Sensor Solo.2f08e297.svg";